<template>
  <div class="animated fadeIn">
    <Tables ref="tableGrid"
            :columns="['NOME', 'PA' , 'NOME DE USUÁRIO', 'TIPO DE USUÁRIO']"
            :showNew="true"
            :showSearch="true"
            :showReload="true"
            :showTipFooter="false"
            v-on:New="onNew"
            v-on:Search="onShowSearch"
            v-on:Load="onLoad"
            v-on:Edit="onEdit"
            v-on:Reload="onLoad">
      <tr v-for="obj in this.objList" v-bind:key="obj.id">
        <TableColumn :IsText="true" status="obj.inactive ? 0 : 1" v-on:Edit="onEdit(obj)" :value="obj.nome ? obj.nome.toUpperCase() : ''" />
        <TableColumn :IsText="true" status="obj.inactive ? 0 : 1" v-on:Edit="onEdit(obj)" :value="obj.pa ? obj.pa.descricao.toUpperCase() : ''" />
        <TableColumn :IsText="true" status="obj.inactive ? 0 : 1" v-on:Edit="onEdit(obj)" :value="obj.username ? obj.username.toUpperCase() : ''" />
        <TableColumn :IsText="true" status="obj.inactive ? 0 : 1" v-on:Edit="onEdit(obj)" :value="obj.tipoUsuario ? obj.tipoUsuario.toUpperCase() : ''" />
      </tr>
    </Tables>
    <div class="row">
      <div class="col-12 pb-3 pl-4">
        <button type="button" class="btn btn-third btn-sm" v-on:click="$emit('New')" v-b-tooltip.hover :title="'Clique para cadastrar'"><i class="fas fa-user-plus"></i> <span class="d-md-down-none">&nbsp; Nova</span></button>
      </div>
    </div>
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
import UserRepository from '@/shared/http/repositories/nxSenhas/usuario.js'
import SidebarSearch from '@/views/private/configurations/ajuizamento/SidebarAjuizamento.vue'

export default {
  name: 'Totem',
  mixins: [ActionsForm],
  data () {
    return {
      filters: null,
      data: null,
      form: null,
      showModal: false
    }
  },
  components: { SidebarSearch },
  methods: {
    onLoad () {
      this.onLoadAll()
    },
    onLoadAll () {
      loading.push()
      UserRepository.GetByTipo('totem', this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then((response) => {
          this.onResultGrid(response)
        })
        .catch((err) => {
          this.onException(err)
        })
    },
    onNew () {
      this.$emit('New')
    },
    onEdit (obj) {
      this.$emit('Edit', obj)
    },
    onDelete (obj) {
      loading.push()
      UserRepository.Delete(obj.id)
        .then((response) => {
          loading.pop()
          toast.success(this.$lang.Common.Alerts.Success)
          this.onLoad()
        })
        .catch(this.onException)
    },
    onSearch (filters) {
      this.filters = filters
      this.$refs.tableGrid.Clear()
      this.$nextTick(() => {
        this.onLoadAll()
      })
    },
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/configurations/nxSenhas/totem/components/list/totemList.vue